/* eslint-disable react/no-unused-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@material-ui/core/styles';
import { EventSeat } from '@material-ui/icons';
import { CardHeader, Avatar, Grid, makeStyles } from '@material-ui/core';
import { connect } from 'react-redux';
import SeatingSelectionModeToggler from './SeatingSelectionModelToggler';

const styles = makeStyles(() => ({
  padding: '0 10px 10px 10px',
  cardHeaderSection: {
    background: '#F4F4F4',
  },
  cardHeaderSectionDark: {
    background: '#2D3436',
  },
}));

function CardHeaderComp(props) {
  const { focusedPricingGroup, selectedGroupName, seatingSelectionMode, selectionModeChanged, typeListing } = props;
  const theme = useTheme();
  const classes = styles();

  return (
    <CardHeader
      data-testid="seating-card-header"
      className={theme.palette.type === 'light' ? classes.cardHeaderSection : classes.cardHeaderSectionDark}
      // prettier-ignore
      avatar={(
        <Avatar aria-label="Inventory" style={{background:"#7D1F8D"}}>
          <EventSeat style={{color:"white"}} />
        </Avatar>
      )}
      title={focusedPricingGroup ? `Seating for group: ${selectedGroupName}` : 'Seating'}
      // prettier-ignore
      action={(
        <Grid container style={{paddingTop:"10px"}} justifyContent='space-between' alignItems='flex-start'>
          <Grid item style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
            <SeatingSelectionModeToggler
              seatingSelectionMode={seatingSelectionMode}
              selectionModeChanged={selectionModeChanged}
              enabled={typeListing === 'seatgeek' || 'ticketnetwork'}
            />
          </Grid>
        </Grid>
      )}
    />
  );
}

CardHeaderComp.propTypes = {
  focusedPricingGroup: PropTypes.number.isRequired,
  selectedGroupName: PropTypes.string.isRequired,
  typeListing: PropTypes.string.isRequired,
  seatingSelectionMode: PropTypes.string.isRequired,
  selectionModeChanged: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  return {
    focusedPricingGroup: state.pricing.ui.focusedPricingGroup,
    selectedGroupName: state.pricing.selectedGroup?.name,
    typeListing: state.pricing.focusedPricingGroupMarketplace,
  };
}

export default connect(mapStateToProps)(CardHeaderComp);
